import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 12px;
  border-radius: ${RADII.field};
  margin-top: 4px;
  margin-right: 8px;
  border: 1px solid ${COLORS.border};
  background-color: ${COLORS.primaryTint};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${COLORS.fill};
  }
`

export const BannerText = styled.span`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${COLORS.textPrimary};
`

export const Highlight = styled.span`
  color: ${COLORS.primary};
  font-weight: 700;
`
